import MachineSpeedMinuteWidgetContainer from "./MachineSpeedMinuteWidgetContainer";
export type { MachineSpeedMinuteApiResponse } from "./MachineSpeedMinute";

export default MachineSpeedMinuteWidgetContainer;
